module.exports = __webpack_public_path__ + "media/video.d0deb43b.mp4";